import React from "react";
import { useGetPokemonByNameQuery } from "../../../api/demoApi";

export default function DemoApi() {
  const { data, error, isLoading } = useGetPokemonByNameQuery("bulbasaur");
  return (
    <div>
      {" "}
      <div className="App">
        {error ? (
          <>Oh no, there was an error</>
        ) : isLoading ? (
          <>Loading...</>
        ) : data ? (
          <>
            <h3>{data.species.name}</h3>
            <img src={data.sprites.front_shiny} alt={data.species.name} />
          </>
        ) : null}
      </div>
    </div>
  );
}
